import axios, {
    AxiosError,
    AxiosResponse,
    InternalAxiosRequestConfig,
  } from "axios";
import config from "../config.js";
import { Token } from "../utils/localStorage.util";

const apiAutenticacao = axios.create({
    baseURL: config.REACT_APP_HOST_API_AUTENTICACAO,
});

apiAutenticacao.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    const token = Token.getToken();
    if (token) {
      config.headers.Authorization = token;
    }

    if (!config.headers["Content-Type"]) {
        config.headers["Content-Type"] = "application/json";
    }

    return config;
  },
  (error: AxiosError) => {
    Promise.reject(error);
  }
);

apiAutenticacao.interceptors.response.use(
  (response: AxiosResponse) => {
    return response.data;
  },

  async function (error: AxiosError) {
    if (error?.code === "ERR_NETWORK") {
      return;
    }

    return Promise.reject(error);
  }
);

// todo: fazer consumir end-points
export async function getMenuList(){
    return await apiAutenticacao.get("/relatorios/")
}

export default apiAutenticacao;